import * as tslib_1 from "tslib";
import { Cursor } from './cursor';
var FormCursor = (function (_super) {
    tslib_1.__extends(FormCursor, _super);
    function FormCursor(cursor, form) {
        var _this = _super.call(this) || this;
        _this.cursor = cursor;
        _this.form = form;
        return _this;
    }
    FormCursor.prototype.isEmpty = function () {
        return this.cursor.isEmpty();
    };
    FormCursor.prototype.head = function () {
        var value = this.cursor.head();
        return value.coerce(this.form);
    };
    FormCursor.prototype.step = function () {
        this.cursor.step();
    };
    FormCursor.prototype.skip = function (count) {
        this.cursor.skip(count);
    };
    FormCursor.prototype.hasNext = function () {
        return this.cursor.hasNext();
    };
    FormCursor.prototype.nextIndex = function () {
        return this.cursor.nextIndex();
    };
    FormCursor.prototype.next = function () {
        var _a = this.cursor.next(), value = _a.value, done = _a.done;
        return { value: value && value.coerce(this.form), done: done };
    };
    FormCursor.prototype.hasPrevious = function () {
        return this.cursor.hasPrevious();
    };
    FormCursor.prototype.previousIndex = function () {
        return this.cursor.previousIndex();
    };
    FormCursor.prototype.previous = function () {
        var _a = this.cursor.next(), value = _a.value, done = _a.done;
        return { value: value && value.coerce(this.form), done: done };
    };
    FormCursor.prototype.delete = function () {
        this.cursor.delete();
    };
    return FormCursor;
}(Cursor));
export { FormCursor };
var FormPairCursor = (function (_super) {
    tslib_1.__extends(FormPairCursor, _super);
    function FormPairCursor(cursor, keyForm, valueForm) {
        var _this = _super.call(this) || this;
        _this.cursor = cursor;
        _this.keyForm = keyForm;
        _this.valueForm = valueForm;
        return _this;
    }
    FormPairCursor.prototype.isEmpty = function () {
        return this.cursor.isEmpty();
    };
    FormPairCursor.prototype.head = function () {
        var pair = this.cursor.head();
        return [pair[0].coerce(this.keyForm), pair[1].coerce(this.valueForm)];
    };
    FormPairCursor.prototype.step = function () {
        this.cursor.step();
    };
    FormPairCursor.prototype.skip = function (count) {
        this.cursor.skip(count);
    };
    FormPairCursor.prototype.hasNext = function () {
        return this.cursor.hasNext();
    };
    FormPairCursor.prototype.nextIndex = function () {
        return this.cursor.nextIndex();
    };
    FormPairCursor.prototype.next = function () {
        var _a = this.cursor.next(), value = _a.value, done = _a.done;
        return { value: value && [value[0].coerce(this.keyForm), value[1].coerce(this.valueForm)], done: done };
    };
    FormPairCursor.prototype.hasPrevious = function () {
        return this.cursor.hasPrevious();
    };
    FormPairCursor.prototype.previousIndex = function () {
        return this.cursor.previousIndex();
    };
    FormPairCursor.prototype.previous = function () {
        var _a = this.cursor.next(), value = _a.value, done = _a.done;
        return { value: value && [value[0].coerce(this.keyForm), value[1].coerce(this.valueForm)], done: done };
    };
    FormPairCursor.prototype.delete = function () {
        this.cursor.delete();
    };
    return FormPairCursor;
}(Cursor));
export { FormPairCursor };
//# sourceMappingURL=data:application/json;base64,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